// src/shared/ensure-xlsx.js - the spreadsheet library (SheetJS) loads only when something needs it (v136.8).
//
// Until v136.8 admin.html loaded xlsx.full.min.js (882 KB raw, about 290 KB compressed) from cdnjs as a blocking tag
// in its head, on every admin load, for the few screens that read or write a spreadsheet (the 16 Oct 2026 page-weight
// audit). Now every place that touches XLSX first calls ensureXlsx(): it resolves at once when the library is already
// there, otherwise it adds the same cdnjs tag and resolves when it has run. One load at a time, shared by every bundle
// (the promise lives on window, because each bundle has its own copy of this file). A failed load rejects with a
// plain message the caller shows, and the next call tries again.
export const XLSX_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.18.5/xlsx.full.min.js';
export const XLSX_FAILED = 'The spreadsheet library did not load. Check the connection and try again.';

function g() { return typeof window !== 'undefined' ? window : globalThis; }

export function xlsxReady() {
  const w = g();
  return !!(w.XLSX || (typeof XLSX !== 'undefined' && XLSX));
}

export function ensureXlsx() {
  const w = g();
  if (w.XLSX) return Promise.resolve(w.XLSX);
  if (typeof XLSX !== 'undefined' && XLSX) return Promise.resolve(XLSX);
  if (w.__shiftXlsxLoad) return w.__shiftXlsxLoad;
  if (typeof document === 'undefined') return Promise.reject(new Error(XLSX_FAILED));
  const p = new Promise(function (resolve, reject) {
    const s = document.createElement('script');
    s.src = XLSX_SRC;
    s.async = true;
    const fail = function () {
      w.__shiftXlsxLoad = null;   // the next call tries again
      if (s.parentNode) s.parentNode.removeChild(s);
      reject(new Error(XLSX_FAILED));
    };
    s.onload = function () {
      if (w.XLSX) { resolve(w.XLSX); return; }
      fail();
    };
    s.onerror = fail;
    (document.head || document.documentElement).appendChild(s);
  });
  w.__shiftXlsxLoad = p;
  return p;
}
